import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Params, Router, UrlTree } from '@angular/router';
import { ConnectionService } from '@services/connection-service';

import { AllocatedRegimen } from '../app-constant-types';

export const regimenProductsDetailGuard: CanActivateFn = async (route: ActivatedRouteSnapshot): Promise<boolean | UrlTree> => {
  const router = inject(Router);
  const connectionService = inject(ConnectionService);
  const { queryParams }: { queryParams: Params } = route;

  const regimens = await connectionService.fetchRegimens(queryParams?.regimenId, false);
  const regimen = regimens.find((each: AllocatedRegimen): boolean => each.class === queryParams?.class);

  if (regimen.active) return true;

  return router.createUrlTree(['user', 'regimen', 'revamp-products'], { queryParams });
};
